(function() {
  function getModal() {
    return document.getElementById('TaxExemptModal');
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return false;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    document.documentElement.classList.add('tax-exempt-modal-open');
    return false;
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return false;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('tax-exempt-modal-open');
    return false;
  }

  window.openTaxExemptModal = openModal;
  window.closeTaxExemptModal = closeModal;

  document.addEventListener('DOMContentLoaded', function() {
    var modal = getModal();
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  });

  document.addEventListener('click', function(event) {
    var openTrigger = event.target.closest('.cart__tax-exempt-link');
    if (openTrigger) {
      event.preventDefault();
      openModal();
      return;
    }

    var closeTrigger = event.target.closest('.tax-exempt-modal__close');
    if (closeTrigger) {
      event.preventDefault();
      closeModal();
      return;
    }

    var modal = getModal();
    if (modal && event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeModal();
  });
})();
